module.exports = __webpack_public_path__ + "img/apple-wallet.51e7c9bf.svg";